import _assign from 'lodash/assign';
import ActionTypes from '../constants/ActionTypes';
import initialState from '../store/initialState';

export default (state = initialState.testSolutionSet, action) => {
  switch (action.type) {
    case `${ActionTypes.GET_TEST_SOLUTIONSET}_SUCCESS`: {
      return _assign({}, state, action.payload);
    }
    // Todo: Check and remove this
    case `${ActionTypes.GET_API_V1_TEST_SOLUTIONSET}_SUCCESS`: {
      return _assign({}, state, action.payload);
    }
    default:
      return state;
  }
};
